<div class="h-full w-full flex flex-col overflow-hidden">
    <ng-container *ngIf="isShowChart then stackedChart else tableData"></ng-container>
</div>

<ng-template #stackedChart>
    <div class="chart-container h-full">
        <app-bar-chart [chartLabels]="chartLabels" [chartDataSet]="stackChartData" [stacked]="true"
            [showHorizontalGridLines]="true" [showTooltips]="false"></app-bar-chart>
    </div>
</ng-template>

<ng-template #tableData>
    <div class="table-container">
        <app-data-table [data]="sessionSummaryData" [columns]="sessionsColumns" sortActive="weekStart" sortDirection="asc"
            smallRowHeight="true" [layoutFixed]="false">
        </app-data-table>
    </div>
</ng-template>